/*
 * @Author: Long
 * @Date: 2021-05-04 15:40:45
 * @LastEditors: Long
 * @LastEditTime: 2021-05-13 11:26:27
 */
const service = require('@/assets/js/request')
const env = process.env

class Partners {
  /**
   * 获取合作伙伴
   */
  static getLinksList (target) {
    service.request({
      method: 'POST',
      url: 'getLinksList'
    }).then(res => {
      if (res.code === '2001') {
        for (let i = 0; i < res.data.length; i++) {
          var item = res.data[i]
          if (item.link_image !== '') {
            item.link_image = env.IMG_URL + item.link_image
          }
        }
        target.list = res.data
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default Partners



// WEBPACK FOOTER //
// ./src/views/Partners/Partners.js